import { render, staticRenderFns } from "./pcgslist.vue?vue&type=template&id=6cce44c0&"
import script from "./pcgslist.vue?vue&type=script&lang=js&"
export * from "./pcgslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports